import axios from 'axios'
export default {

  async add (colaborator) {
    try {
      colaborator.updated_at = Date.now()
      colaborator.created_at = Date.now()
      colaborator.active = true
      delete colaborator._id
      const response = await axios.post('collaborators/add', colaborator)
      if (response.status === 200) {
        console.log('Colaborador agregado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al agregar al colaborador:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al agregar al colaborador:', error)
      return false
    }
  },

  async edit (colaborator) {
    try {
      colaborator.updated_at = Date.now()
      delete colaborator.password
      const response = await axios.patch('collaborators/update', colaborator)
      if (response.status === 200) {
        console.log('Colaborador editado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al editar el Colaborador:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al editar el Colaborador:', error)
      return false
    }
  },

  async changeActive (colaborator) {
    try {
      colaborator.active = !colaborator.active
      colaborator.updated_at = Date.now()
      const response = await axios.patch('collaborators/active', colaborator)
      if (response.status === 200) {
        console.log('Colaborador editado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al editar el Colaborador:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al editar el Colaborador:', error)
      return false
    }
  },

  async delete (colaborator) {
    try {
      colaborator.deleted_at = Date.now()
      const response = await axios.patch('collaborators/delete', colaborator)
      if (response.status === 200) {
        console.log('colaborator editado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al editar el colaborator:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al editar el colaborator:', error)
      return false
    }
  },

  async paswword (colaborator) {
    try {
      colaborator.updated_at = Date.now()
      const response = await axios.patch('collaborators/password', colaborator)
      if (response.status === 200) {
        console.log('password editado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al editar el password:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al editar el password:', error)
      return false
    }
  },

  async list (businesId, search) {
    try {
      const response = await axios.get('collaborators/list?business=' + businesId + '&search=' + search)
      return response.data
    } catch (error) {
      return []
    }
  }
}
